if (!customElements.get('media-wrapper')) {
  customElements.define(
    'media-wrapper',
    class MediaWrapper extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.header = document.querySelector('.header-wrapper');
        this.announcementBar = document.querySelector('.announcement-bar');
        this.mount = this.querySelector('.pmslider-mount');

        if (!this.mount) {
          this.observer = new MutationObserver((records, obs) => {
            for (const record of records) {
              for (const node of record.addedNodes) {
                if (node.classList?.contains('pmslider-mount')) {
                  obs.disconnect();
                  this.mount = node;
                }
              }
            }
          });

          this.observer.observe(this, { childList: true, subtree: true });
        }

        this.mediaQuery = window.matchMedia('(min-width: 750px)');
        this.mediaQueryListener = (e) => {
          this.isScrollListenerActive = e.matches
          this.onWindowScroll();
        };
        this.mediaQuery.addEventListener('change', this.mediaQueryListener);
        this.isScrollListenerActive = this.mediaQuery.matches;

        this.onWindowScroll();
        this.scrollListener = () => window.requestAnimationFrame(this.onWindowScroll.bind(this));
        window.addEventListener('scroll', this.scrollListener);
      }

      disconnectedCallback() {
        this.observer.disconnect();
        if (this.mediaQuery && this.mediaQueryListener) this.mediaQuery.removeEventListener('change', this.mediaQueryListener)
        if (this.scrollListener) window.removeEventListener('scroll', this.scrollListener)
      }

      onWindowScroll() {
        if (!this.mount) return

        const isScrollingDown = window.scrollY > this.lastScrollPosition;
        this.lastScrollPosition = window.scrollY;

        const rect = this.mount.getBoundingClientRect();

        const defaultTopOffset = 20;
        const defaultTopOffsetStr = defaultTopOffset + 'px';
        const maxTopOffset = this.getBoundingClientRect().height - rect.height;


        if (!this.isScrollListenerActive) {
          this.mount.style.position = '';
          this.mount.style.top = '';
          return;
        }

        if (rect.height < window.innerHeight - defaultTopOffset - (this.announcementBar?.offsetHeight ?? 0)) {
          this.mount.style.position = 'sticky';
          this.mount.style.top = defaultTopOffsetStr;
          return;
        }

        if (this.mount.style.position === '' || this.mount.style.top === '') {
          this.mount.style.position = 'sticky';
          this.mount.style.top = defaultTopOffsetStr;
        } else {
          if (isScrollingDown) {
            if (this.mount.style.position === 'sticky' && rect.bottom > window.innerHeight - 21) {
              this.mount.style.top = Math.max(0, Math.min(maxTopOffset, Math.round(window.scrollY + rect.top - defaultTopOffset - this.header?.clientHeight - this.announcementBar?.clientHeight))) + 'px';
              this.mount.style.position = 'relative';
            } else if (this.mount.style.position === 'relative' && rect.bottom <= window.innerHeight - 22) {
              this.mount.style.top = window.innerHeight - rect.height - 22 + 'px';
              this.mount.style.position = 'sticky';
            }
          } else {
            if (this.mount.style.position === 'sticky' && rect.top < defaultTopOffset) {
              this.mount.style.top = Math.max(0, Math.min(maxTopOffset, Math.round(window.scrollY + rect.top - defaultTopOffset - this.header?.clientHeight - this.announcementBar?.clientHeight))) + 'px';
              this.mount.style.position = 'relative';
            } else if (this.mount.style.position === 'relative' && rect.top >= defaultTopOffset) {
              this.mount.style.top = defaultTopOffsetStr;
              this.mount.style.position = 'sticky';
            }
          }
        }
      }
    }
  );
}
